import { css } from '@/styled-system/css';

export const stackedViewActionStyles = css.raw({
  display: { base: 'flex', md: 'grid' },
  gridTemplateRows: 'auto auto',
  gridTemplateColumns: '1fr 1fr',
  gap: 'tight',
  marginTop: 'default',
});

export const defaultViewActionStyles = css.raw({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: 'tight',
  marginLeft: { base: 'none', md: 'auto' },
  marginTop: { base: 'default', md: 'none' },
});

export const cardStyles = css.raw({
  borderLeftWidth: '3px',
  display: 'flex',
  flexDirection: 'column',
  flexFlow: 'column wrap',
  paddingInline: 'loose',
});

export const strikethroughTextStyles = css.raw({
  textDecoration: 'line-through',
});

// The sections carry the padding instead of the card so the divider between them runs edge to edge.
export const redesignedCardStyles = css.raw({
  display: 'flex',
  flexDirection: 'column',
  padding: 'none',
});

export const redesignedSectionStyles = css.raw({
  padding: 'default',
});

export const drawerSummaryStyles = css.raw({
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  gap: 'default',
  padding: 'default',
});

export const stackedSummaryStyles = css.raw({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: 'tighter',
  padding: 'default',
});

export const drawerFooterStyles = css.raw({
  display: 'flex',
  flexWrap: 'wrap',
  gap: 'tight',
  padding: 'default',
});

export const stackedFooterStyles = css.raw({
  display: { base: 'flex', md: 'grid' },
  flexWrap: 'wrap',
  gridTemplateColumns: '1fr 1fr',
  gap: 'tight',
  padding: 'default',
});
